import PropTypes from "prop-types";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { LoadingContext, actionTypes } from "~/context/LoadingContext";
import { useFetchActiveAndUpcomingEvent } from "~/hooks/api/event/useFetchActiveAndUpcomingEvent";

import { DashboardTile } from "../../shared/DashboardTile/DashboardTile";
import { AvailableEventTile } from "../AvailableEventTile/AvailableEventTile";
import { AvailableEventsCount } from "../AvailableEventsCount/AvailableEventsCount";
import { UpcomingEventTile } from "../UpcomingEventTile/UpcomingEventTile";
import { NoEvent } from "./NoEvent/NoEvent";

export function NextEventTile({ setFetchError, studyLocked }) {
  const { t } = useTranslation();
  const { dispatch } = useContext(LoadingContext);

  const { activeEvents, totalActiveEvent, upcomingEvent, studySiteLocalTime, error, isLoading } = useFetchActiveAndUpcomingEvent(
    () => {
      setFetchError("events.active_events", false);
    },
    () => {
      setFetchError("events.active_events", true);
    },
  );

  useEffect(() => {
    const LOADING_KEY = "next-event";
    const type = isLoading
      ? actionTypes.ADD_LOADING_ITEM
      : actionTypes.REMOVE_LOADING_ITEM;

    dispatch({
      type,
      key: LOADING_KEY,
    });
  }, [dispatch, isLoading]);

  const testId = "next-event-tile";

  if (isLoading) {
    return <DashboardTile />;
  }

  if (error) {
    return (
      <DashboardTile disabled hasError testId={testId}>
        <h2>{t("home.next_event.upcoming_event")}</h2>
      </DashboardTile>
    );
  }

  return (
    <>
     {(totalActiveEvent === 0 || studyLocked) && <NoEvent testId={testId} studyLocked={studyLocked} />}
      <AvailableEventsCount count={totalActiveEvent} />
      {activeEvents.map((event) => (
        <AvailableEventTile
          key={event.formId}
          event={event}
          now={studySiteLocalTime}
        />
      ))}
      {upcomingEvent && (
        <UpcomingEventTile event={upcomingEvent} now={studySiteLocalTime} />
      )}
    </>
  );
}

NextEventTile.propTypes = {
  setFetchError: PropTypes.func.isRequired,
  studyLocked: PropTypes.bool.isRequired,
};
